// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"419":"tenor0","474":"tenor2","505":"tenor4","656":"tenor10","785":"tenor6"}[chunkId] || chunkId) + ".js";
};